$(document).on('click', '[data-filtering-status] button', function(){
  console.log('click')
  if($(this).hasClass('active')){
    $(this).removeClass('active')
    $('#search_status').val('')
  }else{
    $(this).parents('[data-filtering-status]').find('button').removeClass('active')
    $(this).addClass('active')
    $('#search_status').val($(this).attr('value'))
  }

  $('.search_subpage').submit()
});
